/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const cardCss = css({
  color: colorsPalette.black,
  cursor: 'pointer',
  textDecoration: 'none',
  borderBottomLeftRadius: 32,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 460,
  [MediaQueries.mdAndUp]: {
    maxWidth: 'none',
    height: '100%',
  },
  '&:hover': {
    boxShadow: shadows.shadow80,
    '.result-cards-info': {
      borderColor: colorsPalette.transparent,
    },
  },
});

export const featuredCss = css(typography.effra12Link, {
  position: 'absolute',
  fontWeight: fontWeights.medium,
  textTransform: 'uppercase',
  backgroundColor: colorsPalette.white,
  marginTop: 12,
  marginLeft: 12,
  padding: '2px 6px',
  paddingTop: 3,
  borderRadius: 2,
});

export const imageCss = css({
  display: 'block',
  width: '100%',
  height: 184,
  objectFit: 'cover',

  [MediaQueries.lgAndUp]: {
    height: 227,
  },
});

export const cardInfoCss = css({
  border: `1px solid rgba(213, 208, 196, 0.5)`,
  borderTop: 0,
  padding: '20px 16px 26px',
  display: 'flex',
  borderBottomLeftRadius: 32,
  flexDirection: 'column',
  [MediaQueries.mdAndUp]: {
    flex: '1 0 auto',
  },
  [MediaQueries.lgAndUp]: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
});

export const titleAddressCss = css({
  marginBottom: 20,
});

export const cardTitleCss = css(typography.effra22, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
});

export const cardAddressCss = css(typography.effra14, {
  color: colorsPalette.grey60,
});

export const solutionsItemsWrapperCss = css({ marginBottom: 24 });

export const solutionItemCss = css({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 6,
});

export const solutionItemNameCss = css(typography.effra16, {
  color: colorsPalette.black,
});

export const solutionItemPriceCss = css(typography.effra14, {
  textAlign: 'right',
  color: colorsPalette.teal,
  [MediaQueries.mdAndUp]: {
    ...typography.effra16,
  },
});

export const footerDataCss = css({
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const locationItemCss = css(typography.effra14, {
  display: 'flex',
  alignItems: 'center',
  color: colorsPalette.grey60,
});

export const solutionIconCss = css({
  marginRight: 10,
  color: colorsPalette.black,
  verticalAlign: 'middle',
  width: 13,
  height: 13,
});

export const imageBrandCss = css({
  width: 79,
  height: 33,
  margin: '0 auto',
  display: 'block',
});

export const partnerTextCss = css({
  fontSize: 10,
  color: colorsPalette.grey60,
});
